export const PAYMENT_SUCCESS = "Payment Success"
export const PAYMENT_START = "Payment Start"

export const GenericPaymentActions = {

  /**
   * Triggers loading screen when the payment starts
   *
   */
  startPayment: () => dispatch => {
    let action = createAction(PAYMENT_START, {})
    dispatch(action)
  },

  /**
   * Redirects a payment on success
   *
   * @param paymentResponse {String} : The response received when the payment is done
   * and dispatch the action that reflects the effects of it.
   */
  paymentSuccess: (paymentResponse, screen) => dispatch => {
      let action = createAction(PAYMENT_SUCCESS, {paymentResponse, screen})
      dispatch(action)
  },

}

function createAction(type, actionParameters = {}) {
    return {type, ...actionParameters}
}
